var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backlist inconbox"},[_c('a',{attrs:{"href":_vm.back_url}},[_vm._v("Back to list")])])
}
var staticRenderFns = []

export { render, staticRenderFns }